export const BASE_URL_DOCKER = "https://api.petlanddxb.com/api";

export const WITHOUT_API = "https://api.petlanddxb.com";

// export const BASE_URL_DOCKER = "https://dev-api.petlanddxb.com/api";

// export const WITHOUT_API = "https://dev-api.petlanddxb.com";

export const getApiUrl = (endpoint: string) => BASE_URL_DOCKER + endpoint;
export const getApiUrlWithoutApi = (endpoint: string) => WITHOUT_API + endpoint;

export const ADMIN_LOGIN = getApiUrl("/auth/admin-login");

export const ADMIN_LOGOUT = getApiUrl("/auth/logout");

export const ADMIN_REARRANGE_UI = getApiUrl("/admin/RearrangeUI");

export const ADMIN_GET_UI_ORDER = getApiUrl("/admin/GetUIConfigByClientType");

export const CREATE_SERVICE = getApiUrl("/admin/service/createService");
export const UPDATE_SERVICE = getApiUrl("/admin/service/updateService");
export const GET_ALL_SERVICE = getApiUrl("/admin/service/GetAllServices");
export const GET_SERVICE_BY_ID = getApiUrl("/admin/service/Getservicebyid");
export const DELETE_SERVICE_BY_ID = getApiUrl("/admin/service/DeleteService");

export const DASHBOARD_DATA = getApiUrl("/admin/dashboard");

export const DASHBOARD_LOW_STOCK_PRODUCTS = getApiUrl(
  "/admin/dashboard/low-stock-products",
);
export const DASHBOARD_ORDER_STATUS_ANALYTICS = getApiUrl(
  "/admin/dashboard/order-status-analytics",
);
export const DASHBOARD_CUSTOMER_ANALYTICS = getApiUrl(
  "/admin/dashboard/customer-analytics",
);
export const GET_CATEGORIES = getApiUrl("/admin/categories/tree");
export const ADD_SUBCATEGORY = getApiUrl("/admin/categories/create");
export const DOWNLOAD_CATEGORIES = getApiUrl("/admin/reference/export");
export const SYSTEM_DEFINED_CATEGORIES = getApiUrl(
  "/admin/categories/system-defined",
);
export const ADMIN_CATEGORIES = getApiUrl("/admin/categories");

export const UPLOAD_INVENTORY = getApiUrl("/admin/upload");
export const BATCH_SUMMARY = getApiUrl("/admin/summary");
export const BATCH_STATUS = getApiUrl("/admin/batch-status");
export const BATCH_ERRORS = getApiUrl("/admin/batches");
export const BATCH_PUBLISH = getApiUrl("/admin/publish");
export const BATCH_VALIDATE = getApiUrl("/admin/validate");

export const INVENTORY_EXPORT = getApiUrl("/admin/inventory/export");

export const GET_ALL_PACKAGES = getApiUrl("/admin/service/GetAllPackages");

export const UPLOAD_FILE = getApiUrl("/admin/home/uploadFile");

export const CREATE_ADD_ON = getApiUrl("/admin/service/createAdd-On");
export const GET_ADD_ONS = getApiUrl("/admin/service/getAdd-OnsByPackageId");
export const GET_ADD_ONS_BY_ID = getApiUrl("/admin/service/getAdd-OnById");
export const UPDATE_ADD_ON = getApiUrl("/service/updateAdd-On");

//Footer Api
export const CREATE_CARRIER_JOB = getApiUrl("/admin/footer/career/create-job");
export const GET_ALL_JOBS = getApiUrl("/admin/footer/career/get-all-jobs");
export const GET_JOB_BY_ID = getApiUrl("/admin/footer/career/get-job-by-id");
export const UPDATE_CAREER_JOB = getApiUrl("/admin/footer/career/update-job");
export const UPDATE_JOB_STATUS = getApiUrl(
  "/admin/footer/career/update-status",
);
export const UPDATE_FEATURED_JOB = getApiUrl(
  "/admin/footer/career/update-featured",
);
export const GET_JOB_APPLICANTS = getApiUrl(
  "/admin/footer/career/get-job-applications",
);
export const UPDATE_APPLICANTS_STATUS = getApiUrl(
  "/admin//footer/career/update-application-status",
);

export const CREATE_FAQ = getApiUrl("/admin/footer/faq/create");
export const UPDATE_FAQ = getApiUrl("/admin/footer/faq/update");
export const DELETE_FAQ = getApiUrl("/admin/footer/faq/delete");
export const GET_FAQ_BY_ID = getApiUrl("/admin/footer/faq/get-by-id");
export const FAQ_GET_ALL = getApiUrl("/admin/footer/faq/get-all");
export const FAQ_UPDATE_STATUS = getApiUrl("/admin/footer/faq/update-status");
export const FAQ_UPDATE_SORT_ORDER = getApiUrl(
  "/admin/footer/faq/update-sort-order",
);
//// QUERY //
export const GET_QUERY_LIST = getApiUrl("/admin/customers/admin_query");
export const RESPONED_TO_QUERY = getApiUrl(
  "/admin/customers/admin_query_respond",
);

//page//

export const CREATE_PAGE = getApiUrl("/admin/footer/page/create");
export const UPDATE_PAGE = getApiUrl("/admin/footer/page/update");
export const GET_PAGE_BY_ID = getApiUrl("/admin/footer/page/get-by-id");
export const PAGE_GET_ALL = getApiUrl("/admin/footer/page/get-all");
export const PAGE_UPDATE_STATUS = getApiUrl("/admin/footer/page/update-status");

//// blog ///

export const CREATE_BLOG = getApiUrl("/admin/footer/blog/create");
export const UPDATE_BLOG = getApiUrl("/admin/footer/blog/update");
export const GET_ALL_BLOG = getApiUrl("/admin/footer/blog/get-all");
export const GET_BLOG_BY_ID = getApiUrl("/admin/footer/blog/get-by-id");
export const UPDATE_BLOG_STATUS = getApiUrl("/admin/footer/blog/update-status");
export const UPDATE_BLOG_FEATURED = getApiUrl(
  "/admin/footer/blog/update-featured",
);

export const UPDATE_ADD_ON_STATUS = getApiUrl(
  "/admin/service/updateAdd-OnStatus",
);
export const UPDATEADD_ON_SORT_ORDER = getApiUrl(
  "/admin/service/updateAdd-OnSortOrder",
);

/// Brands //////

export const CREATE_BRANDS = getApiUrl("/admin/brands/create");
export const BRAND_COMMON = getApiUrl("/admin/brands");

/////// Package api //////

export const CREATE_PACKAGE = getApiUrl("/admin/service/CreatePackage");

export const UPDATE_PACKAGE = getApiUrl("/admin/service/updatePackage");

export const GET_PACKAGE_BY_SERVICE_ID = getApiUrl(
  "/admin/service/getpackagebyserviceid",
);

export const GET_PACKAGE_BY_PACKAGE__ID = getApiUrl(
  "/admin/service/getpackagebypackageid",
);

/////// Service working Day //////

export const SAVE_WORKING_DAY = getApiUrl("/admin/service/saveWorkingDay");

export const GET_WORKING_DAY = getApiUrl("/admin/service/getworkingdaysbyid");

/////// BOOKINGS //////
export const GET_BOOKINGS = getApiUrl("/admin/service/get-bookings");
export const CREATE_ADMIN_BOOKINGS = getApiUrl("/admin/service/create-booking");

export const UPDATE_BOOKING_STATUS = getApiUrl("/admin/service/update-status");
export const RESCHEDULE_BOOKING = getApiUrl(
  "/admin/service/booking/reschedule",
);

export const UPDATE_BOOKING_DURATION = getApiUrl(
  "/admin/service/booking/update-duration",
);

export const GET_BOOKING_DETAILS = getApiUrl("/admin/service/booking");
export const GET_DAILY_TIMELINE = getApiUrl(
  "/admin/service/booking/daily-timeline",
);
export const WEEK_OR_MONTH_TIMELINE = getApiUrl(
  "/admin/service/booking/timeline",
);
export const BOOKING_HISTORY = getApiUrl("/admin/service/booking/history");
export const ASSIGN_EMPLOYEE = getApiUrl(
  "/admin/service/booking/assign-employee",
);
export const BOOKING_DASHBOARD = getApiUrl("/admin/service/booking/dashboard");
export const CALCULATE_PETTAXI_PRICE = getApiUrl(
  "/admin/service/pet-taxi/calculate-Price",
);
export const CREATE_CUSTOMER = getApiUrl(
  "/admin/service/admin/create-customer",
);

/// EMPLOYEEE ///

export const CREATE_EMPLOYEE = getApiUrl("/admin/service/employee");
export const GET_EMPLOYEE_BY_SERVICE_ID = getApiUrl(
  "/admin/service/employee/service",
);

//// Service offer ///////

export const CREATE_SERVICE_OFFER = getApiUrl(
  "/admin/service/create-service-offer",
);
export const GET_SERVICE_OFFER = getApiUrl(
  "/admin/service/get-offers-calendar",
);

//// Pet Api //////

export const CREATE_PET = getApiUrl("/admin/pets/create-pet");
export const UPDATE_PET = getApiUrl("/admin/pets/update-pet");
export const UPDATE_PET_STATUS = getApiUrl("/admin/pets/update-pet-status");
export const GET_PET_BY_PET_ID = getApiUrl("/admin/pets/get-pet-by-id");
export const GET_ALL_PETS = getApiUrl("/admin/pets/get-all-pets");

////// BANNER APIS ////

export const GET_SCREEN_AND_SCREEN_SECTIONS = getApiUrl("/admin/screens");
export const ADMIN_SECTION = getApiUrl("/admin/sections");
export const CREATE_OR_GET_BANNER = getApiUrl("/admin/banners");
export const GET_OR_UPDATE_BANNER_BY_ID = getApiUrl("/admin");
export const UPDATE_DISPLAY_ORDER = getApiUrl("/admin/banners/display-order");
export const GET_BANNER_LAYOUT = getApiUrl("/admin/banners/display-order");
export const ADMIN_SECTION_VIDEOS_SUGGESTIONS = getApiUrl("/admin/sections/video-suggestions");


//// coupon ////

export const COUPON_CURD = getApiUrl("/admin/copuon");
export const COUPON_LIST = getApiUrl("/admin/copuon/list");

//// Admin Products ////

export const ADMIN_PRODUCTS = getApiUrl("/admin/AdminProducts");
export const ADMIN_INVENTORY_DOWNLOAD = getApiUrl(
  "/admin/AdminProducts/inventory/download",
);
export const ADMIN_PRODUCTS_CHANGE_STATUS = getApiUrl(
  "/admin/AdminProducts/products",
);

//// Admin Orders ////
export const ADMIN_ORDERS = getApiUrl("/admin/orders");

export const ADMIN_ORDER_WORKFLOW_REVIEWS_PENDING = getApiUrl(
  "/admin/order-workflow/reviews/pending",
);
export const ADMIN_ORDER_WORKFLOW_REVIEW = getApiUrl(
  "/admin/order-workflow/review",
);
export const ADMIN_ORDER_WORKFLOW = getApiUrl("/admin/order-workflow/orders");
export const ADMIN_ORDER_WORKFLOW_REVISIONS = getApiUrl(
  "/admin/order-workflow/revisions",
);
export const ADMIN_ORDER_WORKFLOW_REVISIONS_PENDING_PAYMENT = getApiUrl(
  "/admin/order-workflow/revisions/pending-payment",
);
export const ADMIN_ORDER_WORKFLOW_CONFIRM_PAYMENT = getApiUrl(
  "/admin/order-workflow/pets/confirm-remaining-payment",
);


//// Bundel API ///

export const BUNDLES = getApiUrlWithoutApi("/Bundles");

/// ATTRIBUTE ////

export const ATTRIBUTE_MASTER = getApiUrl("/admin/attribute-master");

////   ADMIN SUBSCRPTIONS ///

export const ADMIN_SUBSCRIPTION = getApiUrl("/admin/subscriptions");

export const ADMIN_SUBSCRIPTION_DASHBOARD = getApiUrl(
  "/admin/subscriptions/dashboard",
);

////// ABANDONED cart  ////

export const ADMIN_CUSTOMERS = getApiUrl("/admin/customers");
export const ADMIN_CUSTOMERS_WALLET_TRANSACTIONS = getApiUrl(
  "/admin/customers/wallet-transactions",
);
export const ADMIN_CUSTOMERS_REWARD_TRANSACTIONS = getApiUrl(
  "/admin/customers/reward-transactions",
);

export const ADMIN_CUSTOMERS_WALLET_TRANSACTIONS_EXPORT = getApiUrl(
  "/admin/customers/wallet-transactions/export",
);
export const ADMIN_CUSTOMERS_REWARD_TRANSACTIONS_EXPORT = getApiUrl(
  "/admin/customers/reward-transactions/export",
);

export const ABANDONED_CARTS = getApiUrl("/admin/customers/abandoned-carts");

export const ABANDONED_CARTS_DASHBOARD = getApiUrl(
  "/admin/customers/abandoned-carts/dashboard",
);

export const ABANDONED_CART_EXPORT = getApiUrl(
  "/admin/customers/abandoned-carts/export",
);
export const SEND_REMINDERS = getApiUrl(
  "/admin/customers/abandoned-carts/send-reminders",
);

export const IMPERSONATE_CUSTOMER = getApiUrl(
  "/admin/customers/impersonate-customer",
);

//ADMIN SETTINGS //

export const GET_ADMIN_SETTINGS = getApiUrl("/admin/settings");

//--------------------------------------------------
// Cache Management
//--------------------------------------------------

export const CLEAR_SETTINGS_CACHE = getApiUrl("/admin/cache/settings");

export const CLEAR_HOME_CACHE = getApiUrl("/admin/cache/home");

export const CLEAR_SEARCH_CACHE = getApiUrl("/admin/cache/search");

export const CLEAR_DASHBOARD_CACHE = getApiUrl("/admin/cache/dashboard");

export const CLEAR_CART_CACHE = getApiUrl("/admin/cache/cart");

export const CLEAR_ALL_CACHE = getApiUrl("/admin/cache/all");

//ADMIN Email Templates //

export const EMAIL_TEMPLATES = getApiUrl("/admin/email-templates");
export const EMAIL_TEMPLATE_PREVIEW = getApiUrl(
  "/admin/email-templates/preview",
);

export const EMAIL_TEMPLATE_LOOKUPS = getApiUrl(
  "/admin/email-templates/lookups",
);
export const EMAIL_BRANDING_PROFILES = `${EMAIL_TEMPLATES}/branding-profiles`;
export const UPLOAD_EMAIL_BRANDING_PROFILE_LOGO = `${EMAIL_TEMPLATES}/branding-profiles/upload-logo`;

//ANALYTICS ADMIN //

export const ANALYTICS_EVENTS = getApiUrl("/analytics/events");

export const DASHBOARD_ADMIN_ANALYTICS = getApiUrl("/analytics/dashboard");
